import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserHistory } from 'history';
import qs from 'query-string';
import { ThemeProvider } from 'styled-components';

import 'app/styles/index.scss';
import theme from 'app/theme';
import configureSentry from 'app/utils/configureSentry';

import { App } from './components';
import AppContext from './AppContext';
import { createGoogleMapsPlacesService, ValidationService } from './services';

const config = resmioApp.config['src/config'];
const history = createBrowserHistory();
const placesService =
  window.google &&
  window.google.maps &&
  window.google.maps.places &&
  createGoogleMapsPlacesService(window.google.maps);
const validationService = new ValidationService(
  config.form_values.csrfmiddlewaretoken
);

configureSentry(config);

createRoot(document.getElementById('root')).render(
  <ThemeProvider theme={theme}>
    <AppContext.Provider
      value={{
        config,
        history,
        queryParams: qs.parse(window.location.search),
        placesService,
        validationService,
      }}
    >
      <App />
    </AppContext.Provider>
  </ThemeProvider>
);
